import React from "react";
import { Card } from "react-bootstrap";

import { IActiveMDTTabs } from "../../../config/interfaces";
import { useAppSelector } from "../../../redux/Store";
import { ITRFilingSelector } from "../../../redux/slice/ITRFilingSlice";
import PriceDisplay from "../../PriceDisplay";

type Props = {
  activeMDT: IActiveMDTTabs;
};

const TransactionInfoTab: React.FC<Props> = (props: Props) => {
  const { currentFilingPlan } = useAppSelector(ITRFilingSelector);

  const discount = Number(currentFilingPlan?.efilingPlanTransaction?.discount || 0);
  const subtotal = Number(currentFilingPlan?.efilingPlanTransaction?.subtotal || 0) + discount;
  const total = Number(currentFilingPlan?.efilingPlanTransaction?.subtotal || 0);

  return (
    <>
      <section className="mb-5">
        <Card className="more-info-card list-card shadow-none">
          <Card.Body>
            <dl className="eds-list eds-dl eds-inline">
              {currentFilingPlan?.efilingPlanTransaction?.provider && (
                <div className="eds-list--item">
                  <dt>Provider: </dt>
                  <dd>{currentFilingPlan?.efilingPlanTransaction?.provider}</dd>
                </div>
              )}
              {currentFilingPlan?.efilingPlanTransaction?.createdAt && (
                <div className="eds-list--item">
                  <dt>Created At: </dt>
                  <dd>{currentFilingPlan?.efilingPlanTransaction?.createdAt}</dd>
                </div>
              )}
              {currentFilingPlan?.efilingPlanTransaction?.orderId && (
                <div className="eds-list--item">
                  <dt>Order ID: </dt>
                  <dd>{currentFilingPlan?.efilingPlanTransaction?.orderId}</dd>
                </div>
              )}
              {currentFilingPlan?.efilingPlanTransaction?.orderStatus && (
                <div className="eds-list--item">
                  <dt>Order Status: </dt>
                  <dd>{currentFilingPlan?.efilingPlanTransaction?.orderStatus}</dd>
                </div>
              )}
              {currentFilingPlan?.efilingPlanTransaction?.paymentStatus && (
                <div className="eds-list--item">
                  <dt>Payment Status: </dt>
                  <dd>{currentFilingPlan?.efilingPlanTransaction?.paymentStatus}</dd>
                </div>
              )}
              {subtotal && discount ? (
                <div className="eds-list--item">
                  <dt>Subtotal: </dt>
                  <dd>
                    <PriceDisplay price={subtotal} />
                  </dd>
                </div>
              ) : null}
              {discount ? (
                <div className="eds-list--item">
                  <dt>Discount: </dt>
                  <dd>
                    <PriceDisplay price={discount * -1} allowNegative={true} />
                  </dd>
                </div>
              ) : null}
              {total && (
                <div className="eds-list--item">
                  <dt>Total: </dt>
                  <dd>
                    <PriceDisplay price={total} />
                  </dd>
                </div>
              )}
            </dl>
          </Card.Body>
        </Card>
      </section>
    </>
  );
};

export default TransactionInfoTab;
